import React from 'react';
import './NewLabel.scss';


interface NewLabelProps {
  type?: string;
}

const NewLabel = (props: NewLabelProps) => {
  return (
    <div className={"NewLabel " + (props.type ? props.type : '')}>
      NEW
    </div>
  )
}

export default NewLabel;